/**
 * Saloon | Top-down — the switch m11 draws top-right, as a real control.
 *
 * Two places show it: the room header on the table screen (desktop only — it is not
 * drawn where the saloon does not fit), and the Settings sheet, which is the one place
 * every setting lives. Both write the same preference (`prefs.view`) and both read the
 * same rule (`settings/view.ts`), so they cannot disagree.
 */
import { useTableView } from "./view";
import type { TableView } from "./prefs";

const OPTIONS: { id: TableView; label: string; hint: string }[] = [
  { id: "saloon", label: "Saloon", hint: "The table from your chair, the cast standing round it." },
  { id: "topdown", label: "Top-down", hint: "The whole table from above — quicker to read." },
];

export function ViewToggle({ className = "" }: { className?: string }) {
  const { view, fits, set } = useTableView();
  if (!fits) return null;
  return (
    <div className={`money-toggle view-toggle ${className}`.trim()} role="radiogroup" aria-label="Table view">
      {OPTIONS.map((o) => (
        <button key={o.id} type="button" role="radio" aria-checked={view === o.id}
                className={view === o.id ? "is-on" : ""} title={o.hint}
                onClick={() => set(o.id)}>
          {o.label}
        </button>
      ))}
    </div>
  );
}
